import Header from "commons/components/Header/Header";
import { order } from "constraints/PlanEnum";
import { isEmpty } from "lodash";
import CartFilter from "pages/CartPrivate/Filter";
import CartPlan from "pages/CartPrivate/Plan";
import { useMemo, useState } from "react";
import useGetDataCartRealtime from "signalr/useGetDataCartRealtime";
import "./CartPrivate.less";

export const CartPrivate = () => {
  const [filters, setFilters] = useState({
    agentId: null,
    projectId: null,
    areaId: null,
  });

  const { data, loading } = useGetDataCartRealtime({
    agentId: filters.agentId,
    projectId: filters.projectId,
    areaId: filters.areaId,
  });

  const onFilter = (values) => setFilters(values);

  const plans = useMemo(() => {
    if (isEmpty(data)) return {};

    const {
      numberOfApartment,
      floorArray,
      statusStatistics,
      properties: { items },
    } = data;

    const statusSorted = statusStatistics.sort(
      (a, b) => order.indexOf(a.statusName) - order.indexOf(b.statusName)
    );

    const result = floorArray
      .slice(1)
      .reverse()
      .map((floor) => {
        const floorItems = items
          .filter((i) => i.property.actualFloor === floor.index)
          .map((m) => ({ ...m, agentName: data?.agentName ?? m?.agentName }));

        const sortedItems = [];

        for (let i = 0; i < numberOfApartment; i++) {
          const item = floorItems.find((f) => f.property.apartment - 1 === i);
          sortedItems.push(item || null);
        }

        return {
          ...floor,
          items: sortedItems,
        };
      });

    return {
      numberOfApartment,
      statusStatistics: statusSorted,
      result,
    };
  }, [data]);

  return (
    <div className="container-fix parking-container-private">
      <div className="body-container">
        <Header />
        <div
          className="main dark-bg animate__animated animate__fadeIn"
          id="list-room-page"
        >
          <div className="container-fluid">
            <CartFilter
              onFilter={onFilter}
              loading={loading}
              data={plans.statusStatistics}
              length={plans.numberOfApartment}
            />
            <div className="wrapper-content">
              <CartPlan plans={plans} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
